import { ca } from './ldapPropTypes';

import { PureComponent } from 'react';

import { Button } from 'components/Button/Button';
import FormErrorMessage from 'components/FormErrorMessage';
import NumberField from 'components/NumberField';
import SelectField from 'components/SelectField';
import TextField from 'components/TextField';
import ToggleField from 'components/ToggleField';
import { Map as ImmutableMap } from 'immutable';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import handleEvent from 'utils/handleEvent';

export default class RenderServers extends PureComponent {
  static propTypes = {
    ca: ca,
    fields: PropTypes.object,
    formSubmitting: PropTypes.bool.isRequired,
    meta: PropTypes.object,
    msg: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onOpenFileUpload: PropTypes.func.isRequired,
  };

  handleAddServer = handleEvent(() => {
    this.props.fields.push(new ImmutableMap());
    this.props.onChange();
  });

  handleRemoveServer = (index) =>
    handleEvent(() => {
      this.props.fields.remove(index);
      this.props.onChange();
    });

  handleShowUploadFile = handleEvent(() => {
    this.props.onOpenFileUpload();
  });

  render() {
    const {
      fields,
      msg,
      meta: { error },
      ca,
      onChange,
      formSubmitting,
    } = this.props;
    const certificateOptions = ca
      .map((item) => ({
        value: item.get('id'),
        label: item.get('name'),
      }))
      .toJS();
    return (
      <div>
        {fields.map((field, index) => {
          return (
            <div className='mb-6' key={field}>
              <div className='mb-1'>
                <Field
                  className='form-control'
                  component={ToggleField}
                  disabled={formSubmitting}
                  hideStateMessage
                  label={get(
                    msg,
                    ['configurations', 'server', 'startTls'],
                    'StartTLS',
                  )}
                  labelPosition='right'
                  msg={msg}
                  name={`${field}.startTls`}
                  onChange={onChange}
                  type='checkbox'
                  wrapperClassName='float-left mt-2 mr-3'
                />
              </div>
              <div className='form-group flow-root'>
                <Field
                  className='form-control'
                  component={TextField}
                  label={get(msg, ['configurations', 'server', 'url'])}
                  msg={msg}
                  name={`${field}.url`}
                  onChange={onChange}
                  wrapperClassName='float-left'
                />
                <div className='ml-lgu-5 float-left'>
                  <Field
                    className='form-control'
                    component={NumberField}
                    label={get(msg, ['configurations', 'server', 'port'])}
                    msg={msg}
                    name={`${field}.port`}
                    onChange={onChange}
                    wrapperClassName='server__port'
                  />
                </div>
                <div className='ldap-settings__select-cert ml-lgu-5 float-left'>
                  <Field
                    block
                    component={SelectField}
                    disabled={formSubmitting}
                    id={`${field}.cert`}
                    msg={msg}
                    name={`${field}.cert`}
                    onChange={onChange}
                    options={certificateOptions}
                    placeholder={get(msg, ['configurations', 'server', 'cert'])}
                    type='select'
                    styles={{
                      clearIndicator: (base) => ({
                        ...base,
                        padding: '6px 8px',
                      }),
                      control: (base) => ({ ...base, minHeight: 34 }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        padding: '6px 8px',
                      }),
                    }}
                  />
                </div>
                {fields.length > 1 ? (
                  <Button
                    variant='secondary'
                    accent='negative'
                    className='ml-lgu-5'
                    type='button'
                    onClick={this.handleRemoveServer(index)}
                    icon='fa-trash-can'
                  />
                ) : null}
              </div>
            </div>
          );
        })}
        <div className='mt-lgu-3'>
          <Button
            variant='secondary'
            type='button'
            onClick={this.handleAddServer}
            disabled={formSubmitting}
            icon='fa-plus'
            className='mr-2'
          >
            {get(msg, 'configurations.server.btnAdd')}
          </Button>
          <Button
            variant='secondary'
            disabled={formSubmitting}
            onClick={this.handleShowUploadFile}
            type='button'
            icon='fa-upload'
          >
            {get(msg, ['configurations', 'server', 'btnUpload'])}
          </Button>
        </div>
        {error && typeof error === 'string' && (
          <FormErrorMessage>
            {get(msg, ['validation', error], 'Error')}
          </FormErrorMessage>
        )}
      </div>
    );
  }
}
